import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { ActiveUserConstants } from '../activeusers_api/constatnts/activeusers.constant';
import { RetailStoreConstants } from '../retail_api/constants/retailHq.constants';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { AssetLibraryConstants } from './constants/asset-library.constant';

@Injectable({
  providedIn: 'root'
})
export class HeroTileService {
  buttonName: string;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  heroTileUrl = AssetLibraryConstants.ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId + AssetLibraryConstants.SRT_HERO_TILES;
  customTileUrl = AssetLibraryConstants.ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId + AssetLibraryConstants.SLASH_CUSTOM_HEROTILE;
  GET_HERO_TILE_BY_ID_URL = this.heroTileUrl + AssetLibraryConstants.SLASH;

  SRT_HERO_TILE_URL_S3 = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId +
    AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId +
    AssetLibraryConstants.SRT_HERO_TILES + AssetLibraryConstants.SLASH;

  RETAILEHQ_URL = RetailStoreConstants.SLASH_RETAILER_STORE + RetailStoreConstants.SLASH_RETAILER +
    RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.SLASH + this.userId + RetailStoreConstants.RETAILER_URL;

  GET_TILE_CONTENT_BY_PAGE_ID_URL = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId
    + AssetLibraryConstants.SRT_HERO_TILES + AssetLibraryConstants.SLASH;
  GET_CUSTOM_TILE_CONTENT_BY_PAGE_ID_URL = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId
    + AssetLibraryConstants.CUSTOM_HEROTILES + AssetLibraryConstants.SLASH;
  constructor(private httpMethodsservice: HttpMethodsService) { }
  getAllHeroTileByUser() {
    const loginUserRole = sessionStorage.getItem('userRole');
    const retailerId = sessionStorage.getItem('retailerId');
    let url = this.heroTileUrl;
    if (loginUserRole === GlobalConstants.REGIONALHQ) {
      url = this.heroTileUrl + ActiveUserConstants.RETAILER_ID + ActiveUserConstants.EQUALS + retailerId;
    }

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }
  getAllCustomHeroTileByUser() {
    const url = `${AssetLibraryConstants.ASSET_LIBRARY_USERS}${this.userId}${AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY}${this.userId}${AssetLibraryConstants.SLASH_CUSTOM_HEROTILE}`;

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }

  deleteHeroTileById(heroTileId: string, isCustom?) {
    let url = this.heroTileUrl + AssetLibraryConstants.SLASH + heroTileId;
    if (isCustom) {
      url = this.customTileUrl + AssetLibraryConstants.SLASH + heroTileId;
    }

    return this.httpMethodsservice.delete(url)
      .pipe(map((res: any) =>
        res));
  }

  createHeroTile(addObject: string) {
    const url = this.heroTileUrl;

    return this.httpMethodsservice.post(url, addObject)
      .pipe(map((res: any) =>
        res));
  }

  editHeroTileById(inputJson: string, id: string) {
    const url = this.heroTileUrl + AssetLibraryConstants.SLASH + id;

    return this.httpMethodsservice.put(url, inputJson)
      .pipe(map((res: any) =>
        res));
  }

  getHeroTileById(id: string) {
    const url = this.GET_HERO_TILE_BY_ID_URL + id;

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) => res));
  }

  getHeroTileDataByTileId(tileId: string, dataType: string) {
    const url = this.SRT_HERO_TILE_URL_S3
      + tileId + AssetLibraryConstants.SLASH + dataType;

    return this.httpMethodsservice.getImage(url, true)
      .pipe(map((res: any) =>
        res));
  }

  putS3HeroTileDataByTileId(image: File, imageType: string, tileId: string, dataType: string) {
    const url = this.SRT_HERO_TILE_URL_S3 + tileId + dataType;

    return this.httpMethodsservice.putImage(url, image, imageType, true)
      .pipe(map((res: any) =>
        res));
  }

  deleteS3HeroTileDataByTileId(tileId: string, dataType: string, isCustom?) {
    let url = this.SRT_HERO_TILE_URL_S3 + tileId + dataType;
    if (isCustom) {
      url = `${AssetLibraryConstants.S3_ASSET_LIBRARY_USERS}${this.userId}${AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY}${this.userId}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${tileId}${AssetLibraryConstants.SLASH}${dataType}`
    }
    return this.httpMethodsservice.delete(url, true)
      .pipe(map((res: any) =>
        res));
  }

  getAllRetailerInfo() {
    const url = this.RETAILEHQ_URL;

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }

  sendHeroTileToRetailer(heroTileToShare: string) {
    const url = this.heroTileUrl + AssetLibraryConstants.SLASH + heroTileToShare;

    return this.httpMethodsservice.patch(url, heroTileToShare)
      .pipe(map((res: any) =>
        res));
  }
  createCustomTile(payload) {
    const url = `${AssetLibraryConstants.ASSET_LIBRARY_USERS}${this.userId}${AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY}${this.userId}${AssetLibraryConstants.SLASH_CUSTOM_HEROTILE}`;
    return this.httpMethodsservice.post(url, payload)
      .pipe(map((res: any) =>
        res));
  }
  updateCustomTile(payload, tileId) {
    const url = `${AssetLibraryConstants.ASSET_LIBRARY_USERS}${this.userId}${AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY}${this.userId}${AssetLibraryConstants.SLASH_CUSTOM_HEROTILE}${AssetLibraryConstants.SLASH}${tileId}`;
    return this.httpMethodsservice.put(url, payload)
      .pipe(map((res: any) =>
        res));
  }
  uploadImage(file, id, path, type) {
    const url = `${AssetLibraryConstants.S3_ASSET_LIBRARY_USERS}${this.userId}${AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY}${this.userId}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${id}${AssetLibraryConstants.SLASH}${path}`
    return this.httpMethodsservice.putImage(url, file, type, true)
      .pipe(map((res: any) =>
        res));
  }
  getUploadImage(id, path, isMain) {
    let url;
    url = `${AssetLibraryConstants.S3_ASSET_LIBRARY_USERS}${this.userId}${AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY}${this.userId}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${id}${AssetLibraryConstants.SLASH}${path}`;
    return this.httpMethodsservice.getImage(url, true)
      .pipe(map((res: any) =>
        res));
  }

  putS3CustomTileContentByPageId(image: File, imageType: string, logoContentId: string, pageId: string) {
    const url = `${AssetLibraryConstants.S3_ASSET_LIBRARY_USERS}${this.userId}${AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY}${this.userId}${AssetLibraryConstants.SRT_HERO_TILES}${AssetLibraryConstants.SLASH}${logoContentId}${AssetLibraryConstants.SLASH}${pageId}`
    return this.httpMethodsservice.putImage(url, image, imageType, true)
      .pipe(map((res: any) =>
        res));
  }
}
